/**
 * @generated SignedSource<<0de779a47766c7f9aa2d40825736de2e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespLayout_viewer$data = {
  readonly itemSearch: {
    readonly displayUriRef: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_itemSearch" | "SbRespFollowSearchBanner_itemSearch" | "SbSharedHead_itemSearch" | "SbSharedRefetchContainer_itemSearch" | "useSbSharedPageTracking_itemSearch" | "useSearchCorrections_itemSearch">;
  };
  readonly regionalInfo?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefetchContainer_regionalInfo">;
  } | null> | null;
  readonly shippingFilters?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_shippingFilters" | "SbSharedRefetchContainer_shippingFilters">;
  } | null> | null;
  readonly user?: {
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_user" | "useSbSharedPageTracking_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_viewer">;
  readonly " $fragmentType": "SbRespLayout_viewer";
};
export type SbRespLayout_viewer$key = {
  readonly " $data"?: SbRespLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v1 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v2 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "disableForceFacet"
    },
    {
      "kind": "RootArgument",
      "name": "disableNonParameterizedUrlRedirects"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "fetchSb"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "guestId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasPersonalizedFilter"
    },
    {
      "kind": "RootArgument",
      "name": "includeSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin"
    },
    {
      "kind": "RootArgument",
      "name": "numOfItemsToInflate"
    },
    {
      "kind": "RootArgument",
      "name": "originalUrl"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "personalizationId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "regions"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userHasConfirmedOrders"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespComponents_viewer"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "disableForceFacet",
            "variableName": "disableForceFacet"
          },
          {
            "kind": "Variable",
            "name": "disableNonParameterizedUrlRedirects",
            "variableName": "disableNonParameterizedUrlRedirects"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "guestId",
            "variableName": "guestId"
          },
          {
            "kind": "Variable",
            "name": "includeSponsoredItems",
            "variableName": "includeSponsoredItems"
          },
          {
            "kind": "Variable",
            "name": "localeOrigin",
            "variableName": "localeOrigin"
          },
          {
            "kind": "Variable",
            "name": "numOfItemsToInflate",
            "variableName": "numOfItemsToInflate"
          },
          {
            "kind": "Variable",
            "name": "originalUrl",
            "variableName": "originalUrl"
          },
          {
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
          },
          {
            "kind": "Variable",
            "name": "priceBookName",
            "variableName": "priceBookName"
          },
          {
            "kind": "Variable",
            "name": "regions",
            "variableName": "regions"
          },
          (v0/*:: as any*/),
          {
            "kind": "Variable",
            "name": "userCountryCode",
            "variableName": "userCountryCode"
          },
          {
            "kind": "Variable",
            "name": "userHasConfirmedOrders",
            "variableName": "userHasConfirmedOrders"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "personalizationId"
          }
        ],
        "concreteType": "ItemSearchQueryConnection",
        "kind": "LinkedField",
        "name": "itemSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayUriRef",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useSearchCorrections_itemSearch"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SbSharedRefetchContainer_itemSearch"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useSbSharedPageTracking_itemSearch"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SbSharedHead_itemSearch"
          },
          {
            "condition": "fetchSb",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SbRespComponents_itemSearch"
              }
            ]
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SbRespFollowSearchBanner_itemSearch"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useSbSharedPageTracking_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbRespComponents_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchRegionalInfo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*:: as any*/),
            (v2/*:: as any*/)
          ],
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_regionalInfo"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "hasPersonalizedFilter",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*:: as any*/),
            (v0/*:: as any*/),
            (v2/*:: as any*/)
          ],
          "concreteType": "ShippingFilterType",
          "kind": "LinkedField",
          "name": "shippingFilters",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_shippingFilters"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbRespComponents_shippingFilters"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "c6ee3309cb6cd234664f1b27a5fc761f";

export default node;
